/** Shared API origin for authenticated and public HTTP clients. */
export function getApiBaseUrl(): string {
  // In dev, route through the Vite proxy (`vite.config.mts`) to avoid browser CORS blocks.
  if (import.meta.env.DEV) {
    return '/';
  }
  const raw = import.meta.env.VITE_APP_API_URL as string | undefined;
  if (raw && raw.trim().length > 0) {
    return raw.endsWith('/') ? raw : `${raw}/`;
  }
  return 'http://localhost:6104/';
}

/** API origin without trailing slash (for asset URLs and absolute auth paths). */
export function getApiOrigin(): string {
  const base = getApiBaseUrl().replace(/\/$/, '');
  if (base) return base;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
